import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import Tiles from './components/HelpAndSupportTiles';
import { Link } from 'react-router-dom';

const t = (key: string, options?) => translate('ui', key, options);

const useStyles = makeStyles((theme: Theme) => {
  return {
    mainContainer: {
      paddingLeft: theme.spacing(30),
      paddingRight: theme.spacing(30),
      paddingBottom: theme.spacing(10),
    },
    pageHeader: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(2),
      alignItems: 'flex-end',
    },
    secondaryLink: {
      textDecoration: 'none !important',
      color: theme.palette.black.main + ' !important',
      paddingRight: theme.spacing(4),
      fontFamily: 'HWT Futura',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline !important',
      },
    },
    dFlex: {
      display: 'flex',
    },
  };
});

const HelpAndSupport: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer} style={{ flexGrow: 1 }}>
      <Grid container item xs={12} className={classes.pageHeader}>
        <Grid item xs={6}>
          <Typography variant="h1" component="h1" style={{ fontWeight: 'bold' }}>
            {t('helpAndSupport.title')}
          </Typography>
        </Grid>
        <Grid item xs={6} className={classes.dFlex} alignItems="flex-end" justifyContent="flex-end">
          <Link to="/home?tour=true" className={classes.secondaryLink}>
            {t('home.pageTour')}
          </Link>
        </Grid>
      </Grid>
      <Divider />
      <Tiles />
    </div>
  );
};

export default HelpAndSupport;
